import React from 'react';
import PropTypes from 'prop-types';
import { getExternalUrl } from '../../../../config';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_GEO_CHECK_TITLE,
	ONBOARDING_GEO_CHECK_DESCRIPTION,
	ONBOARDING_GEO_CHECK_CTA,
} from '../../../../constants/Copy';

const GeoCheck = () => (
	<FullPageMessage
		button={{
			href: getExternalUrl('welcome'),
			text: ONBOARDING_GEO_CHECK_CTA,
		}}
		title={ONBOARDING_GEO_CHECK_TITLE}
		description={ONBOARDING_GEO_CHECK_DESCRIPTION}
	/>
);

GeoCheck.propTypes = {
	history: PropTypes.object.isRequired,
};

export default GeoCheck;
